import React, { useState } from 'react';
import { FiHome, FiGlobe, FiChevronDown } from 'react-icons/fi';
import ReactCountryFlag from "react-country-flag"
import './App.css';

function App() {
  const [languageBox, setLanguageBox] = useState('none')
  const [selectedLanguage, setSelectedLanguage] = useState('pt-br');

  console.log(' Join us :) https://discord.gg/rUArCff');

  function handleLanguageChange() {
    if(languageBox === 'flex'){
      setLanguageBox('none');
    } else {
      setLanguageBox('flex');
    }
  }
  function handleSelectLanguage(event) {
    const language = event.target.value;
    setSelectedLanguage(language);
  }

  return (
    <div className="App">
      <header>
        <div className='page-title'>
          <h1>BraBBot</h1>
        </div>
        <div className='home-page'>
          <a className='home' href='#home'><FiHome color='#8BE9FD' size={16}/></a>
        </div>
        <div className='links'>
          <a href='#about'>{selectedLanguage === 'pt-br' ? 'Sobre o Bot' : 'About the bot'}</a>
          <a href='https://discord.com/oauth2/authorize?client_id=717920083489456148&permissions=52288&scope=bot'>{selectedLanguage === 'pt-br' ? 'Adicionar' : 'Add'}</a>
          <a href='https://discord.gg/rUArCff'>{selectedLanguage === 'pt-br' ? 'Entrar no server de suporte' : 'Enter the support server'}</a>
          <a href='#team'>{selectedLanguage === 'pt-br' ? 'Nossa equipe' : 'Our Team'}</a>
        </div>
        <div className='change-language' onClick={handleLanguageChange}>
  
            <button className='change-language-button'><FiGlobe color='#fff' size={20}/><FiChevronDown color='#fff' size={16}/></button>
            <div className='languages-box' style={{display: languageBox, flexDirection: "column"}}>
                <button onClick={handleSelectLanguage} value='pt-br'><ReactCountryFlag countryCode="BR" svg /> Português (Brazil)</button>
                <button onClick={handleSelectLanguage} value='en'><ReactCountryFlag countryCode="US" svg />Inglês (USA)</button>
            </div>
        </div>
        <a href='#updates' className='att-link'>{selectedLanguage === 'pt-br' ? 'Atualizações' : 'Updates'}</a>

      </header>
      <div className='page-content'>
      <div className='chat-box'>
      
    
    </div>
    <div className='info-bot-box'>
      <h1>BRA<strong>BB</strong>OT</h1>
      <h2>{selectedLanguage === 'pt-br' ? 'Brabbot tem diversas funcionalidedes diferenciadas pera diversos servidores. Cada um pode usá-lo da maneira que quiser,para pegar informações, imagens, etc. Chame-o agora para seu server, digite --help e divirta-se com seus comandos' : 'Brabbot has several features differentiated by different servers. Everyone can use the way they want to obtain information, images, etc. Now, for your server, type --help and have fun with your commands'}</h2>
      <a href='https://discord.com/oauth2/authorize?client_id=717920083489456148&permissions=52288&scope=bot'><button>{selectedLanguage === 'pt-br' ? 'Adicionar Bot' : 'Add Bot'}</button></a>
    </div>
    <div className='about'>
    <section id='about'>
      <div className='bot-info'>
          <h1>{selectedLanguage === 'pt-br' ? 'Sobre o ' : 'About the '}<strong>{selectedLanguage === 'pt-br' ? 'bot' : 'bot'}</strong></h1>
          <h2>{selectedLanguage === 'pt-br' ? 'Bot desenvolvido com javascript, com vários comandos. Se quiser ver todos eles, o adicione em seu servidor e digite --help. Tem alguma sugestão para o bot ? Fale conosco em nosso servidor de suporte. Sempre estaremos lá.' : 'Bot developed with javascript, with several commands. If you want to see all of them, add it to your server and type --help. Do you have any suggestions for the bot? Contact us on our support server. We will always be there.'}</h2>
      </div>
      <div className='js-image'>
        <img draggable="false" className='node' src='https://i0.wp.com/codigosimples.net/wp-content/uploads/2017/03/nodejs.png?fit=500%2C500&ssl=1' alt='node'/>
        <img draggable="false" className='js' src='https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1200px-Unofficial_JavaScript_logo_2.svg.png' alt='js'></img>
      </div>
    </section>
    </div>   
    <section id='team'>
    <div className='team-box'>
      <h1>{selectedLanguage === 'pt-br' ? 'Nossa' : 'Our'} <strong>{selectedLanguage === 'pt-br' ? 'Equipe' : 'Team'}</strong></h1>
      <div className='persons'>

        <div className='person'>
            <h2>Anton Ruiz</h2>
            <img draggable="false" src='https://cdn.discordapp.com/attachments/730055069835329597/730239483257028618/20200707_224920.jpg' alt='Antonio'/>
            <h3>De<strong>sig</strong>ner</h3>
        </div>

        <div className='person'>
            <h2>Guilherme</h2>
            <img draggable="false" src='https://cdn.discordapp.com/attachments/730055069835329597/730421874068029520/unknown.png' alt='Quintella'/>
            <h3>De<strong>sig</strong>ner</h3>
        </div>

        <div className='person'>
            <h2>Rafael Martinez</h2>
            <img draggable="false" src='https://cdn.discordapp.com/attachments/730055069835329597/730563143188611112/2Q.png' alt='Rafael'/>
            <h3>Server <strong>Ma</strong>nager</h3>
        </div>

        <div className='person'>
            <h2>Arthur Castro</h2>
            <img draggable="false" src='https://cdn.discordapp.com/attachments/730055069835329597/730563681187921990/1594250339989102.JPG' alt='Arthur'/>
            <h3>Software <strong>Engin</strong>eer</h3>
        </div>

        <div className='person'>
            <h2>Henrique Cobra</h2>
            <img draggable="false" src='https://cdn.discordapp.com/attachments/730055069835329597/730565194404593715/foto_1.jpg' alt='Cobra'/>
            <h3>Customer <strong>Excell</strong>ence</h3>
        </div>

    </div>
    </div>
    </section>
    </div>

    <div className='updates-box'>
      <section id='updates'>
          <h1>{selectedLanguage === 'pt-br' ? 'Atualizações' : 'Updates'}</h1>
          <h2>DD/MM/AA - TESTE</h2>
          <h2>DD/MM/AA - TESTE</h2>
          <h2>DD/MM/AA - TESTE</h2>
          <h2>DD/MM/AA - TESTE</h2>
          <h2>DD/MM/AA - TESTE</h2>
      </section>
    </div>

    <footer>
        <h3>© Copyright Brabbot 2020</h3>
        <a href='google.com'>{selectedLanguage === 'pt-br' ? 'Adicionar' : 'Add'}</a>
    </footer>

    </div>
  );
}

export default App;
